import { Link } from 'react-router-dom';

import Button from '@/components/ui/buttons/Button';
import useAuthentication from '@/hooks/common/useAuthentication.ts';

import CSSModule from './EmailConfirmation.module.scss';

const EmailConfirmation: React.FC = () => {
  const { isLoggedIn } = useAuthentication();

  return (
    <div className={CSSModule.EmailConfirmation}>
      <div>
        <h3 className={CSSModule.EmailConfirmation__Title}>
          メール送信が完了しました
        </h3>
        <div className={CSSModule.EmailConfirmation__Description}>
          届いたメールに記載されているURLから
          <br />
          パスワードを再設定してください。
        </div>
        <Button
          tag={Link}
          to={isLoggedIn ? '/mypage/profile' : '/login'}
          color="outline"
          className={CSSModule.EmailConfirmation__BackToLogin}
        >
          {isLoggedIn ? 'マイページに戻る' : 'ログイン画面に戻る'}
        </Button>
      </div>
    </div>
  );
};

export default EmailConfirmation;
